var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 11.9981C2.40039 14.5441 3.41178 16.9858 5.21207 18.7861C7.01236 20.5864 9.45408 21.5978 12.0001 21.5978C14.5461 21.5978 16.9878 20.5864 18.7881 18.7861C20.5884 16.9858 21.5998 14.5441 21.5998 11.9981C21.5998 9.45213 20.5884 7.01041 18.7881 5.21012C16.9878 3.40983 14.5461 2.39844 12.0001 2.39844C9.45408 2.39844 7.01236 3.40983 5.21207 5.21012C3.41178 7.01041 2.40039 9.45213 2.40039 11.9981Z",
    fill: "#F26D64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 11.9981C2.40039 14.5441 3.41178 16.9858 5.21207 18.7861C7.01236 20.5864 9.45408 21.5978 12.0001 21.5978C14.5461 21.5978 16.9878 20.5864 18.7881 18.7861C20.5884 16.9858 21.5998 14.5441 21.5998 11.9981C21.5998 9.45213 20.5884 7.01041 18.7881 5.21012C16.9878 3.40983 14.5461 2.39844 12.0001 2.39844C9.45408 2.39844 7.01236 3.40983 5.21207 5.21012C3.41178 7.01041 2.40039 9.45213 2.40039 11.9981Z",
    fill: "url(#paint0_linear_1584_67894)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 11.9981C2.40039 14.5441 3.41178 16.9858 5.21207 18.7861C7.01236 20.5864 9.45408 21.5978 12.0001 21.5978C14.5461 21.5978 16.9878 20.5864 18.7881 18.7861C20.5884 16.9858 21.5998 14.5441 21.5998 11.9981C21.5998 9.45213 20.5884 7.01041 18.7881 5.21012C16.9878 3.40983 14.5461 2.39844 12.0001 2.39844C9.45408 2.39844 7.01236 3.40983 5.21207 5.21012C3.41178 7.01041 2.40039 9.45213 2.40039 11.9981Z",
    fill: "url(#paint1_linear_1584_67894)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 11.9981C2.40039 14.5441 3.41178 16.9858 5.21207 18.7861C7.01236 20.5864 9.45408 21.5978 12.0001 21.5978C14.5461 21.5978 16.9878 20.5864 18.7881 18.7861C20.5884 16.9858 21.5998 14.5441 21.5998 11.9981C21.5998 9.45213 20.5884 7.01041 18.7881 5.21012C16.9878 3.40983 14.5461 2.39844 12.0001 2.39844C9.45408 2.39844 7.01236 3.40983 5.21207 5.21012C3.41178 7.01041 2.40039 9.45213 2.40039 11.9981Z",
    fill: "url(#paint2_linear_1584_67894)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1151 14.0097L11.4669 13.2007C11.4669 13.2007 11.7756 12.4033 10.7047 12.5949L7.69915 13.3531C7.69915 13.3531 7.42704 13.4309 7.30654 13.6316C7.40527 13.6239 7.50427 13.6201 7.6033 13.62C9.30091 13.62 10.7039 14.7255 10.928 16.1605C12.4621 16.4924 16.1294 16.7837 17.056 12.3135C17.0559 12.3135 15.6645 15.6005 11.1151 14.0097ZM12.913 9.90585L12.5456 10.6876C12.5456 10.6876 12.2134 11.4536 13.2882 11.2934L16.3016 10.625C16.3016 10.625 16.9895 10.4491 16.6846 9.88632L15.0431 7.14261C15.0431 7.14261 14.5311 6.68923 14.1911 7.22859L13.8276 8.01027C13.8237 8.01027 8.26589 5.89971 6.94482 11.4223C6.94482 11.4223 8.4183 8.25259 12.913 9.90585Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6033 13.62C7.50427 13.6201 7.40527 13.6239 7.30654 13.6316C7.236 13.749 7.21688 13.9088 7.3352 14.1195L9.05491 16.8984C9.05491 16.8984 9.57082 17.3517 9.90304 16.785L10.247 15.976C10.247 15.976 10.5078 16.0696 10.928 16.1605C10.7039 14.7255 9.30091 13.62 7.6033 13.62Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_67894",
    x1: 12.0001,
    y1: 2.39844,
    x2: 12.0001,
    y2: 21.5978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F69FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0015D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1584_67894",
    x1: 12.0001,
    y1: 2.39844,
    x2: 12.0001,
    y2: 21.5978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0086D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1584_67894",
    x1: 12.0001,
    y1: 2.39844,
    x2: 12.0001,
    y2: 21.5978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62646"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.0387c77ab60ba61f700e7baf19977cc4.svg";
export { ForwardRef as ReactComponent };